import type { User } from '@core/entities/User';
import type { AuthRepository } from '@core/repositories/AuthRepository';

export class GetCurrentUserUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(): Promise<User | null> {
    return this.authRepository.getCurrentUser();
  }
}
